import { render } from "./App.vue?vue&type=template&id=2393d1a2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2393d1a2&lang=css"
script.render = render

export default script